import React,{useState} from 'react';
import Analizador from './Analizador';
import './Analizador.css';

function VerAnalizador(){
    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if(code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    return (
        <Analizador code={code}/>        
    );
};

export default VerAnalizador;